import { Group, Text, ThemeIcon, Tooltip } from "@mantine/core";
import {
  IconMoodEmptyFilled,
  IconMoodHappyFilled,
  IconMoodSadFilled,
  IconMoodSmileFilled,
  IconX,
} from "@tabler/icons-react";

function getDetails(value, row) {
  let result = { label: "", icon: "", color: "" };
  if (value <= 1 && row.email_validated) {
    result = { label: "Inactif", icon: <IconMoodSadFilled />, color: "red.5" };
  }
  if (value > 1) {
    result = {
      label: "Faible",
      icon: <IconMoodEmptyFilled />,
      color: "orange.5",
    };
  }
  if (value >= 10) {
    result = {
      label: "Moyen -",
      icon: <IconMoodSmileFilled />,
      color: "teal.4",
    };
  }
  if (value >= 30) {
    result = {
      label: "Moyen +",
      icon: <IconMoodSmileFilled />,
      color: "teal.4",
    };
  }
  if (value >= 60) {
    result = {
      label: "Elevé",
      icon: <IconMoodHappyFilled />,
      color: "green.6",
    };
  }
  if (!row.email_validated) {
    result = { label: "N.A", icon: "", color: "red.8" };
  }
  return result;
}

const EngagementColumn = ({ value, row }) => {
  const details = getDetails(value, row);
  return (
    <Group>
      <Tooltip label={value}>
        <ThemeIcon
          variant="light"
          color={details.color}
          size={"lg"}
          radius={"xl"}
        >
          {details.icon}
        </ThemeIcon>
      </Tooltip>

      <Text size="lg" c={details.color}>
        {details.label}
      </Text>
    </Group>
  );
};

export default EngagementColumn;
